exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderer-wrapper {\r\n    overflow:hidden;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/inventory/work-order-management/work-order-execution/work-orders/aggrid-custom-cell/filename-cell-renderer.component.css
// module id = ../../../../../src/app/features/inventory/work-order-management/work-order-execution/work-orders/aggrid-custom-cell/filename-cell-renderer.component.css
// module chunks = main